// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S2ILk","buttons":"styles_buttons__1_CaY"};